import { Box, Typography } from '@mui/material';
import React from 'react';

interface NoRecordsMessageProps {
    message: string;
    height?: string;
}

/**
 * Shared by payments pages (schedule-payment, upcoming-payments) for the "no rows" empty state:
 * a centered heading in a fixed-height box. Callers keep their own show/hide condition and pass
 * in the translated message, so behavior (when this renders) is unchanged per page.
 */
const NoRecordsMessage: React.FC<NoRecordsMessageProps> = ({ message, height = 'calc(100dvh - 300px)' }) => (
    <Box display="flex" justifyContent="center" alignItems="center" height={height}>
        <Typography variant="h6" color="textSecondary" textAlign="center">
            {message}
        </Typography>
    </Box>
);

export default NoRecordsMessage;
